import React, { ReactElement } from 'react';
import {
  FieldError,
  FieldErrors,
  FieldValues,
} from 'react-hook-form/dist/types';
import { ObjectSchema } from 'yup';
import useIsRequired from '../../../hooks/useIsRequired';
import SelectField, { SelectFieldProps } from '../SelectField/SelectField';
import styles from '../SelectField/selectField.module.scss';

interface ValidatedTextSelect<T extends FieldValues> extends SelectFieldProps {
  select: React.DetailedHTMLProps<
    React.SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  > & {
    name: keyof T;
  };
  errors: FieldErrors<T>;
  schema: ObjectSchema<T>;
  label: string | ReactElement;
  placeholder?: string;
  strict?: boolean;
}

const ValidatedSelect = <T extends FieldValues>({
  errors,
  schema,
  label,
  select,
  children,
  placeholder,
  strict = false,
}: ValidatedTextSelect<T>): ReactElement => {
  const fname = select.name as string;
  const error = errors[select.name] as FieldError;

  const required = useIsRequired(fname, schema);

  return (
    <SelectField
      children={children}
      select={select}
      error={error}
      placeholder={placeholder}
      strict={strict}
      // We change the label directly intead of passing the required prop
      label={
        label && required ? (
          <React.Fragment>
            {label}
            <span className={styles.asterisk}>{'\u00a0*'}</span>
          </React.Fragment>
        ) : (
          label
        )
      }
    />
  );
};

export default ValidatedSelect;
